import React, { useContext, useState } from "react";
import { Col, Row } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { getEmployeeViewableStatusUpdate } from "../../actionCreator/executiveDetailsActionCreator";
import { subscriptionContentInfo } from "../../config";
import { getPartialPhoneNumber } from "../../utils/utils";
import subscribepopupImg from "../../assets/images/subscribe-now-prompt-img.jpg";
import TrialModal from "../../common/TrialModal";
import { AuthContext } from "../../context/AuthContext";
import TruncateTest from "../../common/TruncateTest";
import industry from "../../assets/svg/industry.svg";
import email from "../../assets/svg/email.svg";
import phone from "../../assets/svg/phone.svg";
import website from "../../assets/svg/website.svg";
import facebook from "../../assets/svg/facebook-f.svg";
import linkedin from "../../assets/svg/linkedin-in.svg";
import twitter from "../../assets/svg/twitter.svg";
import CopyText from "../web2lead/CopyText";

const ExecutiveHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);

  const executiveDetails = useSelector(
    (state) => state.executiveDetailsReducer.executiveDetails
  );
  const getEmployeeViewableData = useSelector(
    (state) => state.executiveDetailsReducer?.executiveEmployeeViewableStatus
  );
  const [showEmail, setShowEmail] = useState(false);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });

  const openInfoModel = () => {
    if (isAuthenticated) {
      setOpenModal({ info: null, open: false });
    } else {
      setOpenModal({ info: null, open: true });
    }
  };

  const redirectToSignup = () => {
    setOpenModal(false);
    navigate("/signup");
  };

  const closeInfoBeforeLogin = () => {
    setOpenModal(false);
  };

  const updateEmailStatus = (row) => {
    setShowEmail(true);
    const payload = {
      id: row.id,
      pageFor: 1,
    };
    dispatch(getEmployeeViewableStatusUpdate("Email", payload));
  };
  const getDetails = (id, name) => {
    let cname = name.replaceAll(" ", "-", name);
    navigate(`/company-summary/${id}/${cname}`);
  };
  return (
    <>
      <div className="common-box-2 mt25">
        <div>
          <div className="d-flex align-items-center gap-20">
            <div className="executivelogobox text-uppercase">
              {executiveDetails?.firstname?.replace(/\s+/g, " ").trim()?.[0]}
              {executiveDetails?.lastname?.replace(/\s+/g, " ").trim()?.[0]}
            </div>

            <div>
              {!!executiveDetails?.fullname && (
                <h3 className="heading18px fw-bold">
                  {executiveDetails?.fullname}
                </h3>
              )}
              {!!executiveDetails?.title && (
                <div className="heading13px">{executiveDetails?.title}</div>
              )}
            </div>
          </div>
          <div>
            <Row
              gutter={[{ xs: 16 }, { xs: 16, md: 24, lg: 32 }]}
              className="mt30 mb30 align-items-center heading13px"
            >
              {!!executiveDetails?.company?.name && (
                <Col xs={16} xl={5} className="d-flex gap-10">
                  <img src={industry} alt="" className="w-20 h-20" />
                  <div className="d-flex flex-column">
                    <span className="fw-bold leading13">Company Name</span>
                    <span
                      className="mt5"
                      onClick={() =>
                        getDetails(
                          `${executiveDetails?.company?.id}`,
                          `${executiveDetails?.company?.name}`
                        )
                      }
                    >
                      {executiveDetails?.company?.name}
                    </span>
                  </div>
                </Col>
              )}
              {!!executiveDetails?.company?.phoneNo && (
                <>
                  <Col xs={0} xl={1}>
                    <div className="vertical-line"></div>
                  </Col>
                  <Col
                    xs={16}
                    xl={5}
                    className="d-flex gap-10"
                  >
                    <img src={phone} alt="" className="w-20 h-20" />
                    <div className="d-flex flex-column">
                      <span className="fw-bold leading13">Phone</span>
                      <span className="mt5">
                        {getPartialPhoneNumber(
                          executiveDetails?.company?.phoneNo
                        )}
                      </span>
                    </div>
                  </Col>
                </>
              )}
              {executiveDetails?.emailId === "exists" && (
                <>
                  <Col xs={0} xl={1}>
                    <div className="vertical-line"></div>
                  </Col>
                  <Col xs={16} xl={5} className="d-flex gap-10">
                    <img src={email} alt="" className="w-20 h-20" />
                    <div className="d-flex flex-column">
                      <span className="fw-bold leading13 mb5">Email</span>
                      {isAuthenticated ? (
                        showEmail &&
                        executiveDetails?.id === getEmployeeViewableData?.id ? (
                          <div className="d-flex align-items-center gap-10">
                            <span className="emailvalue fs-12">
                              {getEmployeeViewableData?.emailId}
                            </span>

                            <CopyText
                              text={getEmployeeViewableData?.emailId}
                              size={14}
                            />
                          </div>
                        ) : (
                          <div
                            className="d-flex gap-10 align-items-center"
                            onClick={() => updateEmailStatus(executiveDetails)}
                          >
                            <i
                              className={
                                executiveDetails?.isdownloadedEmail
                                  ? " btn iconemail emails-open"
                                  : " btn iconemail emails"
                              }
                            ></i>
                            <span>View Email</span>
                          </div>
                        )
                      ) : (
                        <div
                          className="d-flex gap-10 align-items-center"
                          onClick={() => openInfoModel()}
                        >
                          <i className="align-top btn iconemail emails"></i>
                          <span>View Email</span>
                        </div>
                      )}
                    </div>
                  </Col>
                </>
              )}
              {!!executiveDetails?.socialLinks?.length && (
                <>
                  <Col xs={0} xl={1}>
                    <div className="vertical-line"></div>
                  </Col>
                  <Col xs={16} xl={5} className="d-flex gap-10">
                    <img src={website} alt="" className="w-20 h-20" />
                    <div className="d-flex flex-column">
                      <span className="fw-bold leading13">Social</span>
                      <div className="d-flex gap-5 align-items-center mt5">
                        {!!executiveDetails?.socialLinks?.find(
                          (d) => d?.name === "facebook"
                        ) && (
                          <Link
                            to={
                              executiveDetails?.socialLinks?.find(
                                (d) => d?.name === "facebook"
                              )?.proifileUrl
                            }
                            target="_blank"
                            className="social-link-icon"
                          >
                            <img src={facebook} alt="" />
                          </Link>
                        )}
                        {!!executiveDetails?.socialLinks?.find(
                          (d) => d?.name === "Linkedin"
                        ) && (
                          <Link
                            to={
                              executiveDetails?.socialLinks?.find(
                                (d) => d?.name === "Linkedin"
                              )?.proifileUrl
                            }
                            target="_blank"
                            className="social-link-icon"
                          >
                            <img src={linkedin} alt="" />
                          </Link>
                        )}
                        {!!executiveDetails?.socialLinks?.find(
                          (d) => d?.name === "twitter"
                        ) && (
                          <Link
                            to={
                              executiveDetails?.socialLinks?.find(
                                (d) => d?.name === "twitter"
                              )?.proifileUrl
                            }
                            target="_blank"
                            className="social-link-icon"
                          >
                            <img src={twitter} alt="" />
                          </Link>
                        )}
                      </div>
                    </div>
                  </Col>
                </>
              )}
            </Row>

            <TruncateTest description={executiveDetails?.bio} />
          </div>
        </div>
      </div>

      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeInfoBeforeLogin}
          redirectToSignup={redirectToSignup}
          redirect={true}
          buttonText={subscriptionContentInfo.btntext}
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={subscribepopupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                {subscriptionContentInfo.content}
              </p>
            </div>
          }
          modalWidth="400px"
        />
      )}
    </>
  );
};

export default ExecutiveHeader;
